import { navigate } from 'gatsby';

export const NavigationService = {
	redirectToPricingRequestFailed: locale => navigate(`/${locale}/geen-prijzen`, { replace: true }),
	redirectToMyPrices: (locale, params = '') => navigate(`/${locale}/auth/mijn-prijzen${params}`),
};

export const authenticatedRoutes = {
	myPrices: 'mijn-prijzen',
	login: 'login',
};
